export function toUser(userData) {
  /**
   * User
   * {String} userName
   * {String} email
   */
  return {
    userName: userData.user_name,
    email: userData.email
  };
}
export function toTeamMember(teamMemberData) {
  return {
    userId: teamMemberData.user_id,
    firstName: teamMemberData.first_name,
    lastName: teamMemberData.last_name,
    email: teamMemberData.email,
    img: teamMemberData.img,
    isAccountOwner: teamMemberData.is_account_owner,
    roles: teamMemberData.roles,
    joinedAt: teamMemberData.joined_at
  };
}
export function toTeam(teamData) {
  return {
    ownerId: teamData.owner_id,
    members: teamData.members.map(toTeamMember)
  };
}
function toEnterpriseTab(sourceData) {
  const {
    tab_name_key,
    tab_name_en,
    media_root,
    enterprise_version
  } = sourceData;
  return {
    mediaRoot: media_root,
    tabNameEn: tab_name_en,
    tabNameKey: tab_name_key,
    enterpriseVersion: enterprise_version
  };
}
export function toSitesInfo(sitesInfoData) {
  return {
    sitesNumber: sitesInfoData.sites_number,
    hasVisitorUploads: sitesInfoData.has_visitor_uploads,
    hasWixVideoUploads: sitesInfoData.has_wix_video_uploads,
    hasContributors: sitesInfoData.has_contributors,
    team: sitesInfoData.team ? toTeam(sitesInfoData.team) : null,
    country: sitesInfoData.country,
    parentAccountId: sitesInfoData.parent_account_id,
    storageQuotaGracePeriodEndByGroup: sitesInfoData.storage_quota_grace_period_end_by_group,
    enterpriseTabs: sitesInfoData.enterprise_tabs && sitesInfoData.enterprise_tabs.length > 0 ? sitesInfoData.enterprise_tabs.map(toEnterpriseTab) : []
  };
}
export function toManagerInfo(sitesInfoData) {
  return {
    hasOldMedia: sitesInfoData.has_media,
    hasSiteMedia: sitesInfoData.has_site_media,
    migrationStatus: sitesInfoData.migration_status,
    hasVisitorUploads: sitesInfoData.has_visitor_uploads
  };
}